/**
 * HTTP response status codes treated as transient for client-side retry.
 * Keep in sync with transient handling in error policy for ApiError.
 */
export const RETRYABLE_RESPONSE_STATUSES = [408, 425, 429, 500, 502, 503, 504] as const;

export const RETRYABLE_RESPONSE_STATUS_SET = new Set<number>(RETRYABLE_RESPONSE_STATUSES);

export function isRetryableResponseStatus(status: number): boolean {
  return RETRYABLE_RESPONSE_STATUS_SET.has(status);
}
